import React from "react";
import Tabs from "./Tabs";
import Industries from "./Industries";
import Products from "./Products";

class Main extends React.Component {
    render() {
        const {
            isGuideOpen,
            toggleTabs,
            isIndustryActive,
            isProductActive,
            industries,
            products
        } = this.props;

        return (
            <main
                role="main"
                className={`main ${isGuideOpen ? "main--blur" : ""}`}
            >
                <Tabs
                    toggleTabs={toggleTabs}
                    isIndustryActive={isIndustryActive}
                    isProductActive={isProductActive}
                />
                <section className="tile__holder wrapper">
                    {isIndustryActive && (
                        <Industries
                            industries={industries}
                            isIndustryActive={isIndustryActive}
                            className={`tab`}
                        />
                    )}
                    {isProductActive && (
                        <Products
                            products={products}
                            isProductActive={isProductActive}
                            className={`tab`}
                        />
                    )}
                </section>
            </main>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js